import React from 'react'
import t from '~t'
import { Link } from 'react-router-dom'
import { MenuItem, Icon } from '~ui';

export default function BookmarksAddExtensionTabs({ spaceId }) {
    return (
        <MenuItem 
            as={Link}
            to={`/extension/tabs/${spaceId}`}>
            <Icon name='add_tabs' />
            {t.s('saveTabs')}…
        </MenuItem>
    )
}